var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_916_7996",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.99292,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_916_7996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "videocam",
    d: "M3 15.9929C2.5875 15.9929 2.23438 15.846 1.94063 15.5523C1.64688 15.2585 1.5 14.9054 1.5 14.4929V5.49292C1.5 5.08042 1.64688 4.72729 1.94063 4.43354C2.23438 4.13979 2.5875 3.99292 3 3.99292H12C12.4125 3.99292 12.7656 4.13979 13.0594 4.43354C13.3531 4.72729 13.5 5.08042 13.5 5.49292V8.86792L16.5 5.86792V14.1179L13.5 11.1179V14.4929C13.5 14.9054 13.3531 15.2585 13.0594 15.5523C12.7656 15.846 12.4125 15.9929 12 15.9929H3ZM3 14.4929H12V5.49292H3V14.4929Z",
    fill: "#F6F6F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.e440fe72fef4a2daf08e13ed6699a9f0.svg";
export { ForwardRef as ReactComponent };